<template>
  <div class="listing-save" @click.stop="toggleSaved()" @click="show = !show">
    <!-- <v-btn :icon="isBigbutton ? false : true" slot="activator"> -->
    <v-btn 
			:flat="isFlatbutton" 
			:icon="!isBigbutton" 
			:color="buttonfarbe"
			slot="activator"
			:light="lighttext"
		>
      <span v-if="isBigbutton">
				{{ MerkeGemerkt }}
			</span>
      <v-icon :color="farben" :right="isBigbutton">{{ BigButtonIcon }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
	export default {
	//  props: ['id', 'isBigbutton'],
	  props: {
	    id: Number,
	    betrieb: String,
	    company: Object,
	    buttonfarbe: String,
	    isBigbutton: Boolean,
	    lighttext: Boolean,
	    isFlatbutton: Boolean
  },
	  data () {
    return {
	      show: false
    }
  },
	  methods: {
	    toggleSaved () {
	      this.$store.commit('toggleSaved', this.company.id)
	      if (this.company.vollername) {
	        this.$store.dispatch('responseMessage', {
	          type: 'success',
	          text: this.company.vollername + ' ' + this.ResponseMessage
        })
      }
	    }
  },
	  computed: {
	    isListingSaved () {
	      return this.$store.state.saved.saved.find(saved => saved === this.company.id)
	    },
	    MerkeGemerkt () {
	      const saved = this.isListingSaved
	      if (saved) {
	        return 'Gemerkt'
      } else {
	        return 'Merken'
	      }
	    },
	    BigButtonIcon () {
	      if (this.isBigbutton) {
	        return 'favorite'
      } else {
	        return 'favorite'
      }
    },
	    ResponseMessage () {
	      const saved = this.isListingSaved
	      if (saved) {
	        return 'gemerkt'
      } else {
	        return 'nicht mehr gemerkt'
      }
    },
	    farben () {
	      const saved = this.isListingSaved
	      if (saved) {
	        return 'accent'
      } else {
	        return 'grey lighten-1'
      }
    }
	  }
}
	
</script>
<style>
</style>